// import React, { useState, Fragment, useEffect, useRef } from "react";

// import "tachyons";

// import "./style.css";
// // import "bootstrap/dist/css/bootstrap.min.css";

// import data from "./mock-data.json";

// import Cookies from "js-cookie";

// import { Circles } from "react-loader-spinner";

// import { confirmAlert } from "react-confirm-alert";
// import "react-confirm-alert/src/react-confirm-alert.css";
// import { Divider } from "@tremor/react";

// const AdminProfile = () => {
//   const [contacts, setContacts] = useState(data);
//   const [addFormData, setAddFormData] = useState({
//     username: "",
//     email: "",

//     company: "",
//     category: "",
//     phone: "",
//   });

//   const [editFormData, setEditFormData] = useState({
//     id: "",
//     username: "",
//     email: "",
//     joined: "",
//     company: "",
//     category: "",
//     phone: "",
//     status: "",
//   });

//   const [editContactId, setEditContactId] = useState(null);

//   //display success info after successful registration
//   const [success, setSuccess] = useState("");
//   const [deleteState, setDeleteState] = useState("");

//   const [foundErr, setFoundErr] = useState(null);
//   const [foundErrAdd, setFoundErrAdd] = useState(null);
//   const [isLoading, setIsLoading] = useState(null);
//   const [isLoadingAdd, setIsLoadingAdd] = useState(null);
//   const [isLoadingSave, setIsLoadingSave] = useState(null);

//   //analysis Constants
//   const [totalUsers, settotalUsers] = useState(null);

//   const [totalActiveUsers, settotalActiveUsers] = useState(null);

//   //store select values in an array
//   const options = [
//     { value: "", text: "-- select Category --" },
//     { value: "farmer", text: "farmer" },
//     { value: "fieldAdmin", text: "fieldAdmin" },
//   ];
//   const [val, setVal] = useState("");

//   const [names, setNames] = useState({
//     fullname: "",
//     category: options[0].value,
//     username: "",
//     company: "",
//     phone: val,
//     gender: options[0].value,
//     status: "",
//   });

//   useEffect(() => {
//     //fetch agents
//     const fetchProfile = () => {
//       let adminCookie = "";
//       adminCookie = Cookies.get("sessionidadmin");
//       let userid = "";
//       userid = Cookies.get("sessioniduser");
//       if (adminCookie.length >= 1 || userid.length >= 1) {
//         setIsLoading(true);
//         setTimeout(() => {
//           fetch("https://api.terraweb.africa/loadProfile", {
//             method: "post",
//             headers: { "Content-Type": "application/JSON" },
//             body: JSON.stringify({
//               adminid: adminCookie,
//               userid: userid,
//             }),
//           })
//             .then(function (response) {
//               if (response.status === 400) {
//                 throw Error("Wrong credentials");
//               }
//               if (response === 500) {
//                 throw Error("Could not complete request because of an error");
//               }

//               return response.json();
//             })
//             .then((user) => {
//               if (user[0].username.length >= 1) {
//                 //load data

//                 setFoundErrAdd(null);

//                 setIsLoading(null);
//                 setContacts(user);

//                 setSuccess(null);
//                 setDeleteState(null);

//                 //store a name after load to display in the title of the users table
//                 setNames((names) => ({
//                   ...names,
//                   company: user[0].company,
//                 }));
//               } else {
//                 //dont load

//                 setFoundErrAdd(null);
//                 setFoundErr(null);
//                 setIsLoading(null);
//                 setDeleteState(null);
//               }
//             })
//             .catch((err) => {
//               // setFoundErr(err.message);
//               setIsLoading(null);
//               // setFlag(1);
//             });
//         }, 150);
//       } else {
//         setIsLoading(null);
//       }
//     };

//     fetchProfile();
//   }, []);

//   return (
//     <div className="container z-index:100 rounded bg-white  pa3 center br4 mt6 shadow-3">
//       <div className="co-container flex items-center">
  

// <div className="col-md-3 pv5 pa5 flex flex-column items-center tc">
//   <div className="flex flex-column items-center tc">
//     <img
//       className="rounded-circle mt3 mb3"
//       alt="profile"
//       width="150px"
//       src="https://st3.depositphotos.com/15648834/17930/v/600/depositphotos_179308454-stock-illustration-unknown-person-silhouette-glasses-profile.jpg"
//     />
//     <label className="b f3 mt2">
//       {contacts[0].username ? contacts[0].username : ""}
//     </label>
//     <label className="b f4">
//       {contacts[0].email ? contacts[0].email : ""}
//     </label>
//   </div>

//   <div className="flex flex-column items-center mt3">
//     <span className="mt2">
//       <label className="b f4">Status:</label>
//       <label className="ml2 b f3">
//         {contacts[0].status ? contacts[0].status : ""}
//       </label>
//     </span>
//     <span className="mt2">
//       <label className="b f4">Company:</label>
//       <label className="ml2 b f3">
//         {contacts[0].company ? contacts[0].company : ""}
//       </label>
//     </span>
//   </div>
// </div>

//         <div className="col-md-5 pv5 pa4 flex flex-column items-center">
//   <div className="w-100 mw8">
//     <h4 className="b f2 tc mb4">Profile Settings</h4>

//     {/* Full Name */}
//     <div className="mb3">
//       <label className="b f3 db mb1">Full Name</label>
//       <input
//         type="text"
//         className="w-100 pa2 br2 ba b--black-20"
//         placeholder="Full Name"
//         value={contacts[0].fullname ? contacts[0].fullname : ""}
//       />
//     </div>

//     {/* Mobile Number */}
//     <div className="mb3">
//       <label className="b f3 db mb1">Mobile Number</label>
//       <input
//         type="text"
//         className="w-100 pa2 br2 ba b--black-20"
//         placeholder="Phone number"
//         value={contacts[0].phone ? contacts[0].phone : ""}
//       />
//       <label className="b red f5 hover-blue pointer mt2 db">
//         Not Confirmed. Click here to confirm
//       </label>
//     </div>

//     {/* Email */}
//     <div className="mb3">
//       <label className="b f3 db mb1">Email</label>
//       <input
//         type="text"
//         className="w-100 pa2 br2 ba b--black-20"
//         placeholder="Email"
//         value={contacts[0].email ? contacts[0].email : ""}
//       />
//       <label className="b red f5 hover-blue pointer mt2 db">
//         Not Confirmed. Click here to confirm
//       </label>
//     </div>

//     {/* Save Button */}
//     <div className="tc mt4">
//       <button className="bg-orange pa2 br-pill white f3 b hover-bg-orange hover-white">
//         Save Profile
//       </button>
//     </div>
//   </div>
// </div>

//         <div className="col-md-4 pa4 flex flex-column items-center">
//   <div className="w-100 mw6">
//     <h4 className="tc b f3 mb4">Change Password</h4>

//     {/* Current Password */}
//     <div className="mb3">
//       <label className="b f4 db mb1">Current Password</label>
//       <input
//         type="password"
//         className="w-100 pa2 br2 ba b--black-20"
//         placeholder="Current Password"
//       />
//     </div>

//     {/* New Password */}
//     <div className="mb3">
//       <label className="b f4 db mb1">New Password</label>
//       <input
//         type="password"
//         className="w-100 pa2 br2 ba b--black-20"
//         placeholder="New Password"
//       />
//     </div>

//     {/* Confirm New Password */}
//     <div className="mb4">
//       <label className="b f4 db mb1">Confirm New Password</label>
//       <input
//         type="password"
//         className="w-100 pa2 br2 ba b--black-20"
//         placeholder="Confirm New Password"
//       />
//     </div>

//     {/* Button */}
//     <div className="tc">
//       <button className="bg-orange pa2 br-pill white f3 b hover-bg-orange hover-white">
//         Update Password
//       </button>
//     </div>
//   </div>
// </div>

//       </div>
//     </div>
//     //new profile ai
    
//   );
// };
// export default AdminProfile;


// // new AI admin profile
// import React, { useState, useEffect } from "react";
// import Cookies from "js-cookie";
// import data from "./mock-data.json";
// // import "tachyons";
// import "./style.css";


// const AdminProfile = () => {
//   const [contacts, setContacts] = useState(data);
//   const [isLoading, setIsLoading] = useState(false);

//   useEffect(() => {
//     const fetchProfile = () => {
//       let adminCookie = Cookies.get("sessionidadmin") || "";
//       let userid = Cookies.get("sessioniduser") || "";

//       if (adminCookie.length || userid.length) {
//         setIsLoading(true);
//         setTimeout(() => {
//           fetch("https://api.terraweb.africa/loadProfile", {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify({ adminid: adminCookie, userid }),
//           })
//             .then((res) => {
//               if (!res.ok) throw new Error("Failed to fetch profile");
//               return res.json();
//             })
//             .then((user) => {
//               if (user[0]?.username) setContacts(user);
//               setIsLoading(false);
//             })
//             .catch(() => setIsLoading(false));
//         }, 150);
//       }
//     };
//     fetchProfile();
//   }, []);

//   if (isLoading) {
//     return (
//       <div className="tc mt5">
//         <div className="loader">Loading...</div>
//       </div>
//     );
//   }

//   return (
//    <div className="admin-profile-wrapper mt6">

//       <div className="co-container">
//         {/* Profile Sidebar */}
//         <div className="profile-sidebar">
//           <img
//             className="rounded-circle"
//             alt="profile"
//             src="https://st3.depositphotos.com/15648834/17930/v/600/depositphotos_179308454-stock-illustration-unknown-person-silhouette-glasses-profile.jpg"
//           />
//           <h3 className="username">{contacts[0]?.username}</h3>
//           <p className="email">{contacts[0]?.email}</p>

//           <div className="profile-info">
//             <p>
//               <span>Status:</span> {contacts[0]?.status}
//             </p>
//             <p>
//               <span>Company:</span> {contacts[0]?.company}
//             </p>
//           </div>
//         </div>

//         {/* Profile Settings */}
//         <div className="profile-settings">
//           <h4>Profile Settings</h4>

//           {/* Full Name */}
//           <div className="form-group">
//             <label>Full Name</label>
//             <input
//               type="text"
//               value={contacts[0]?.fullname || ""}
//               placeholder="Full Name"
//             />
//           </div>

//           {/* Phone */}
//           <div className="form-group">
//             <label>Mobile Number</label>
//             <input
//               type="text"
//               value={contacts[0]?.phone || ""}
//               placeholder="Phone number"
//             />
//             <span className="confirm-label">Not Confirmed. Click to confirm</span>
//           </div>

//           {/* Email */}
//           <div className="form-group">
//             <label>Email</label>
//             <input
//               type="text"
//               value={contacts[0]?.email || ""}
//               placeholder="Email"
//             />
//             <span className="confirm-label">Not Confirmed. Click to confirm</span>
//           </div>

//           {/* Save */}
//           <div className="btn-container">
//             <button>Save Profile</button>
//           </div>
//         </div>

//         {/* Change Password */}
//         <div className="change-password">
//           <h4>Change Password</h4>

//           <div className="form-group">
//             <label>Current Password</label>
//             <input type="password" placeholder="Current Password" />
//           </div>
//           <div className="form-group">
//             <label>New Password</label>
//             <input type="password" placeholder="New Password" />
//           </div>
//           <div className="form-group">
//             <label>Confirm New Password</label>
//             <input type="password" placeholder="Confirm New Password" />
//           </div>

//           <div className="btn-container">
//             <button>Update Password</button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdminProfile;


// new admin profile 4 with verificatio status
import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import data from "./mock-data.json";
import "./style.css";

const AdminProfile = () => {
  const [contacts, setContacts] = useState(data);
  const [isLoading, setIsLoading] = useState(false);
  const [isResending, setIsResending] = useState(false);
  const [resendMsg, setResendMsg] = useState("");

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [updateMsg, setUpdateMsg] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    const fetchProfile = () => {
      const adminCookie = Cookies.get("sessionidadmin") || "";
      const userid = Cookies.get("sessioniduser") || "";

      if (adminCookie.length || userid.length) {
        setIsLoading(true);
        setTimeout(() => {
          fetch("https://api.terraweb.africa/loadProfile", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ adminid: adminCookie, userid }),
          })
            .then((res) => {
              if (!res.ok) throw new Error("Failed to fetch profile");
              return res.json();
            })
            .then((user) => {
              if (user[0]?.username) setContacts(user);
              setIsLoading(false);
            })
            .catch(() => setIsLoading(false));
        }, 150);
      }
    };
    fetchProfile();
  }, []);

  const handleResendVerification = async () => {
    // if (!contacts[0]?.userid) return;

     const adminCookie = Cookies.get("sessionidadmin") || "";
      const userid = Cookies.get("sessioniduser") || "";

    setIsResending(true);
    setResendMsg("");

    try {
      const res = await fetch("https://api.terraweb.africa/resend-verification", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: contacts[0].email }),
      });

      const result = await res.json();
      if (!res.ok) throw new Error(result || "Failed to resend verification");

      setResendMsg("Verification email sent! Please check your inbox.");
    } catch (err) {
      setResendMsg("Unable to resend verification. Try again later.");
      console.error(err);
    } finally {
      setIsResending(false);
    }
  };


  const handleUpdatePassword = async () => {

     const adminCookie = Cookies.get("sessionidadmin") || "";
      const userid = Cookies.get("sessioniduser") || "";

    // if (!userid||!adminCookie) return;
    const id = userid || adminCookie;
if (!id) return;


    if (!currentPassword || !newPassword || !confirmPassword) {
      setUpdateMsg("Please fill all password fields");
      return;
    }

    if (newPassword !== confirmPassword) {
      setUpdateMsg("New password and confirm password do not match");
      return;
    }

    setIsUpdating(true);
    setUpdateMsg("");

    try {
      const res = await fetch("https://api.terraweb.africa/update", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
      id: id,

          email: contacts[0]?.email,
          newpass:newPassword,
          password: currentPassword,
          confirmPass: confirmPassword,
        }),
      });

      const result = await res.json();

      if (!res.ok) throw new Error(result || "Failed to update password");

      setUpdateMsg("✅ Password updated successfully! Check your email for confirmation.");
      // Reset fields
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
    } catch (err) {
      setUpdateMsg("❌ Unable to update password. Try again later.");
      console.error(err);
    } finally {
      setIsUpdating(false);
    }
  };


  if (isLoading) {
    return (
      <div className="tc mt5">
        <div className="loader">Loading...</div>
      </div>
    );
  }

  const user = contacts[0] || {};
  const verified = user.verified;

  return (
    <div className="admin-profile-wrapper mt6">
      <div className="co-container">
        {/* Profile Sidebar */}
        <div className="profile-sidebar">
          <img
            className="rounded-circle"
            alt="profile"
            src="https://st3.depositphotos.com/15648834/17930/v/600/depositphotos_179308454-stock-illustration-unknown-person-silhouette-glasses-profile.jpg"
          />
          <h3 className="username">{user.username}</h3>
          <p className="email">
            {user.email}{" "}
            {verified ? (
              <span className="verified-badge">Verified</span>
            ) : (
              <span className="not-verified-badge">Not Verified</span>
            )}
          </p>

          {!verified && (
            <>
              <button
                className="resend-btn"
                onClick={handleResendVerification}
                disabled={isResending}
              >
                {isResending ? "Resending..." : "Resend Verification"}
              </button>
              {resendMsg && <div className="resend-msg">{resendMsg}</div>}
            </>
          )}

          <div className="profile-info">
            <p>
              <span>Status:</span> {user.status}
            </p>
            <p>
              <span>Company:</span> {user.company}
            </p>
          </div>
        </div>

        {/* Profile Settings */}
        <div className="profile-settings">
          <h4>Profile Settings</h4>

          {/* Full Name */}
          <div className="form-group">
            <label>Full Name</label>
            <input type="text" disabled value={user.fullname || ""} placeholder="Full Name" />
          </div>

          {/* Phone */}
          <div className="form-group">
            <label>Mobile Number</label>
            <input type="text" disabled value={user.phone || ""} placeholder="Phone number" />
            <span className="confirm-label">Not Confirmed. Click to confirm</span>
          </div>

          {/* Email */}
          <div className="form-group">
            <label>Email</label>
            <input type="text" disabled value={user.email || ""} placeholder="Email" />
            {!verified && (
              <span className="confirm-label" >Not Verified. Click to resend</span>
            )}
          </div>

          {/* Save */}
          {/* <div className="btn-container">
            <button>Save Profile</button>
          </div> */}
        </div>

   {/* Profile Settings */}
        <div className="profile-settings">
          <h4>Change Password</h4>

          <div className="form-group">
            <label>Current Password</label>
            <input
              type="password"
              placeholder="Current Password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>New Password</label>
            <input
              type="password"
              placeholder="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Confirm New Password</label>
            <input
              type="password"
              placeholder="Confirm New Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>


          {/* <div className="btn-container">
            <button>Update Password</button>
          </div> */}

             <div className="btn-container">
            <button onClick={handleUpdatePassword} disabled={isUpdating}>
              {isUpdating ? "Updating..." : "Update Password"}
            </button>
          </div>

          {updateMsg && <div className="resend-msg mt2">{updateMsg}</div>}
        </div>
      </div>
    </div>
  );
};

export default AdminProfile;
